import './VisualPicker.scss';
import classNames from 'classnames';
import { SonarText } from '@ui/text';
import { Else, If, Then, When } from 'react-if';
import { Form, Radio, Tooltip } from 'antd';
import Icon, { CheckOutlined } from '@ant-design/icons';
import React, { useCallback } from 'react';
export const VisualPicker = ({ disabled, groupClassname, groupItemClassname, hidden = false, message, name, options, onChange, title, value }) => {
    const handleOnChange = useCallback((e) => {
        if (onChange) {
            onChange(e.target.value);
        }
    }, [onChange]);
    const handleOnReset = useCallback(() => {
        if (onChange) {
            onChange(undefined);
        }
    }, [onChange]);
    const handleClick = useCallback((clickValue) => {
        if (clickValue === value) {
            handleOnReset();
        }
    }, [handleOnReset, value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(When, { condition: !hidden },
            React.createElement(SonarText, { className: 'h2' }, title)),
        React.createElement(Form.Item, { className: 'visual-picker', hidden: hidden, initialValue: value, name: name, onReset: handleOnReset, valuePropName: 'checked' },
            React.createElement(Radio.Group, { className: classNames('visual-picker-group', groupClassname), defaultValue: value, disabled: disabled, onChange: handleOnChange, value: value }, options.map((option) => React.createElement(Tooltip, { key: option.value, open: option.disabled ? undefined : false, placement: 'bottom', title: message },
                React.createElement(Radio.Button, { className: classNames('visual-picker-group-item', groupItemClassname), disabled: option.disabled || disabled, onClick: () => handleClick(option.value), value: option.value },
                    React.createElement(If, { condition: typeof option.label === 'string' },
                        React.createElement(Then, null,
                            React.createElement(SonarText, { className: 'visual-picker-group-item-title', weight: 'semibold' }, option.label)),
                        React.createElement(Else, null, option.label)),
                    React.createElement(When, { condition: !option.disabled || option.value === value },
                        React.createElement(Icon, { className: 'visual-picker-checkmark-area', component: () => React.createElement(CheckOutlined, { className: 'visual-picker-checkmark-icon' }) })))))))));
};
